import React, { useState } from 'react'
import { Modal } from "antd";
import Close from "../../../../resources/imgs/modal/close.svg";
import { FaChevronRight } from "react-icons/fa";
import Progress from "../../progress";
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg"
import AssessmentWrapper from "../../AssessmentWrapper"
import { useRecoilValue } from 'recoil'
import { loveInterestAtom } from '../../../../state/assessment';

function Module8Instance5(props) {
  const loveInterestObj = useRecoilValue(loveInterestAtom);
  const loveInterest = typeof loveInterestObj === 'object' ? loveInterestObj.loveInterest : loveInterestObj;
  const [phoneNumber, setPhoneNumber] = useState('');
  const [open, setOpen] = useState(false);
  const correctPhoneNumber = props.targetPhoneNumber || '435-638-5526';
  const difficulty = 2;

  const handlePhoneChange = (e) => {
    // Get the raw input value
    let value = e.target.value.replace(/\D/g, ''); // Remove non-digit characters

    // Format the value into the phone number format
    if (value.length <= 3) {
      value = value.replace(/(\d{3})(\d{0,})/, '$1-$2');  // Format as XXX-
    } else if (value.length <= 6) {
      value = value.replace(/(\d{3})(\d{3})(\d{0,})/, '$1-$2-$3');  // Format as XXX-XXX-
    } else {
      value = value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');  // Format as XXX-XXX-XXXX
    }

    // Limit length to 12 characters (XXX-XXX-XXXX format)
    if (value.length > 12) {
      value = value.slice(0, 12); // Truncate if it's longer than 12 characters
    }

    setPhoneNumber(value);  // Update phone number state
  };

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="08." percent={1} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 8</div>
          <div className="module1-body">
            <div className="module1-title">Oh no! {loveInterest}'s number didn't save!  Do your best to enter {loveInterest}'s number again.</div>
          </div>
        </div>
      </div>

      <input
        className="input-number real-input"
        id="phone"
        type="text"
        value={phoneNumber}
        onChange={handlePhoneChange}
        placeholder="XXX-XXX-XXXX"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
      />

      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>
        {phoneNumber &&
          <div
            className="assessment-next-btn"
            onClick={() => { 
              // Calculate per-digit scoring
              const userDigits = phoneNumber.replace(/\D/g, '');
              const correctDigits = correctPhoneNumber.replace(/\D/g, '');
              let correctDigitsCount = 0;
              
              // Compare digit by digit
              for (let i = 0; i < Math.min(userDigits.length, correctDigits.length); i++) {
                if (userDigits[i] === correctDigits[i]) {
                  correctDigitsCount++;
                }
              }
              
              const totalPoints = correctDigitsCount * difficulty;
              const isCorrect = userDigits === correctDigits;
              
              // Record custom scoring
              if (props.recordScore) {
                props.recordScore(isCorrect, { 
                  customPoints: totalPoints,
                  correctDigits: correctDigitsCount,
                  totalDigits: correctDigits.length,
                  difficulty: difficulty,
                  userInput: phoneNumber,
                  expectedInput: correctPhoneNumber
                });
              }
              
              console.log(`Module 8 Instance 2 Score: ${correctDigitsCount}/${correctDigits.length} digits correct, ${totalPoints} points`);
              
              // Delay nextPage to allow score popup to display
              setTimeout(() => {
                props.nextPage();
              }, 2500); // 2.5 seconds to see the score popup
            }}
          >
            Next{" "}
            <div
              style={{
                paddingTop: "5px",
                display: "inline-block",
              }}
            >
              <FaChevronRight color="white" size={16} />
            </div>
          </div>
        }
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className='direction-modal-content'>
            Dessert is done. The guests are getting ready to leave and begin to get up to leave.  {loveInterest} gets up first and glances at you.  You take your chance and ask for {loveInterest}'s number and {loveInterest} whispers it to you so the other guests don't notice. Your job in this
            module is to correctly input {loveInterest}'s number after seeing it for 5 seconds. Make sure you're ready before clicking next. The timer starts right away!
          </div>
        </div>
      </Modal>
    </div>
  )
}

function Module8Wrapper(props) {
  // AssessmentWrapper will clone this component and add recordScore prop
  console.log('🔍 Module8-5 Wrapper props:', Object.keys(props));
  return <Module8Instance5 {...props} />;
}

export default function Index(props) {
  return (
    <AssessmentWrapper moduleType="8" isAdaptive={false}>
      <Module8Wrapper {...props} />
    </AssessmentWrapper>
  );
}
